export default {
  modals: {
    delete_payment_method: {
      title: 'Czy na pewno chcesz usunąć tę metodę płatności?',
    },
  },
  buttons: {
    confirm: 'Potwierdź',
    cancel: 'Anuluj',
  },
  toasts: {
    failed_to_delete_payment_method: 'Nie udało się usunąć metody płatności',
    payment_method_deleted: 'Metoda płatności została usunięta',
  },
};
